export default __webpack_public_path__ + "assets/joel-2.14a7b012.png";